import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	sendTestEmailSuccessFlag: {
		id: 'language-settings.common.send-test-email-success-flag',
		defaultMessage: 'Test email sent to {email}.',
		description: 'Flag when sending a test email with an argument of the current users email',
	},
	sendTestEmailErrorFlag: {
		id: 'language-settings.common.send-test-email-error-flag',
		defaultMessage: "Couldn't send the email. Try again.",
		description: 'Flag when sending a test email failed',
	},
});
